// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sync-confirm-page__notification[data-v-161c8845]{display:flex;align-items:center;gap:16px;background:rgba(255,204,51,.5);border-radius:100px;max-width:638px;color:#333;font-weight:700;font-size:12px;line-height:16px;padding:8px 24px;margin:15px 0 20px}", ""]);
// Exports
module.exports = exports;
